import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":_vm.$t('Merchant ID'),"outlined":"","hide-details":"auto"},model:{value:(_vm.merchantId),callback:function ($$v) {_vm.merchantId=$$v},expression:"merchantId"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }